import { controls,grouped } from "../controls";
const customer_aadhaar_links = {
label: "Customer Aadhaar Links",
pageLabel: "Customer Aadhaar Links",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Customer"}),
...controls.oc({ tab: "filter", c: "Customer", placeHolder: "Customer Code", name: "CustomerAadhaarLink-aadhaar_linked_customer-customer_code",fastpath:"customers"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "CustomerAadhaarLink-aadhaar_linked_customer-customer_display"}),
...controls.displayText({ tab: "filter", label: "Aadhaar"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "CustomerAadhaarLink-aadhaar_linked_customer-customer_kyc-aadhaar",maxlength:14}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Account",star:true}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code", isRequired:true,fastpath:"accounts"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
]
,history:{
perPage: 10,
reportHeader: "Customer Aadhaar Links",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "First Name",accessor: "CustomerAadhaarLink-aadhaar_linked_customer-individual_details-first_name",},
{Header: "Last Name",accessor: "CustomerAadhaarLink-aadhaar_linked_customer-individual_details-last_name",},
{Header: "Full Name",accessor: "CustomerAadhaarLink-aadhaar_linked_customer-institutional_details-full_name",},
{Header: "Customer Type",accessor: "CustomerAadhaarLink-aadhaar_linked_customer-customer_type-customer_type_display",},
{Header: "Account Code",accessor: "CustomerAadhaarLink-account-account_code",},
]}};
export default customer_aadhaar_links;